// Func = limiting Scope for this file
var lastScrollTop = 0
;(function () {
	$(document).ready(function () {
		$('.top-content__slider').on('init', function (event, slick) {
			$('.top-content__slider .slide[data-slick-index=0]').addClass('slide-in')
		})

		$('.top-content__slider').slick()

		$('.top-content__slider').on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				$(
					'.top-content__slider .slide[data-slick-index=' + nextSlide + ']',
				).addClass('slide-in')
				setTimeout(function () {
					$(
						'.top-content__slider .slide[data-slick-index=' +
							currentSlide +
							']',
					).removeClass('slide-in')
				}, 800)
			},
		)

		// Hide RFP Form
		$('#booking-trigger').click(function (e) {
			e.preventDefault()
			$('#booking-content').slideToggle()
		})

		$('.close-rfp').click(function (e) {
			e.preventDefault()
			$('#booking-content').slideToggle()
		})

		const home_body = document.querySelector('body#home')
		if (home_body) {
			/*this function add a class to header when scroll down the page
			/* and change the logo by a new file if needed depending of mockup
			*/
			scrollDownAction(20, 'scroll')
		} else {
			const logo_scroll =
				document.querySelector('.header__logo img').dataset.scroll
			document.querySelector('.header__logo img').src = logo_scroll
		}

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover')
				$('ul.submenu', this).fadeIn(200)
			},
			function () {
				$(this).removeClass('hover')
				$('ul.submenu', this).fadeOut(200)
			},
		)

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true]
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
			if (
				(d1 && date.getTime() == d1.getTime()) ||
				(d2 && date.getTime() == d2.getTime())
			) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT =
			$('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format')
				? $('#CheckIn').data('format')
				: 'mm-dd-yy'
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut').datepicker('setDate', newDate)
				$('#CheckOut').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	})

	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})

		$('.gallery_slider .slick-current').addClass('active')
		$('.gallery_slider .slick-current').prev().addClass('active')
		$('.gallery_slider .slick-current').next().addClass('active')
		$('.gallery_slider').on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				$('.gallery_slider .slick-slide').removeClass('active')
				$(
					'.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]',
				).addClass('active')
				$('.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]')
					.prev()
					.addClass('active')
				$('.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]')
					.next()
					.addClass('active')
				//console.log(nextSlide);
			},
		)
	}

	function navisEmailSignup(formID) {
		$.post(
			site_url + 'ajax/emailsignup.php',
			$('#' + formID).serialize(),
			function (data) {
				if (data.error) {
					if (formID == 'email-signup2') $('#email-error2').html(data.msg)
					else $('#email-error').html(data.msg)
				} else {
					//ga('send', 'event', 'form', 'click', 'specials');
					$('#' + formID).html('<p>Thank You</p>')
				}
			},
			'json',
		)
	}
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling

	const window_height = window.innerHeight
	let animatedEl = document.getElementsByClassName('animate-fade-2')
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect()
		let topPos = viewportOffset.top
		if (topPos <= window_height * 0.8) {
			animatedEl[i].classList.add('fade-in')
		}
	}
	if (st > 800) {
		document.getElementById('booking-trigger').classList.add('show')
	} else {
		document.getElementById('booking-trigger').classList.remove('show')
	}
}

// const tabs = document.querySelectorAll('.apart__content-items');
// tabs.forEach(clickedTab => {
//     clickedTab.addEventListener('click', () => {
//         tabs.forEach(tab => {
//             tab.classList.remove('active');
//         });
//         clickedTab.classList.add('active');
//     });
// });

var tab = {
	nav: null, // holds all tabs
	txt: null, // holds all text containers
	init: function () {
		// tab.init() : init tab interface

		// Get all tabs + contents
		tab.nav =
			document.getElementById('tab-nav') !== null
				? document.getElementById('tab-nav').getElementsByClassName('tabnav')
				: null

		tab.txt =
			document.getElementById('tab-contents') !== null
				? document
						.getElementById('tab-contents')
						.getElementsByClassName('tabtxt')
				: null

		// Error checking
		if (tab.nav === null || tab.txt === null) {
			console.log('ERROR STARTING TABS')
		} else {
			// Attach onclick events to navigation tabs
			for (var i = 0; i < tab.nav.length; i++) {
				tab.nav[i].dataset.pos = i
				tab.nav[i].addEventListener('click', tab.switch)
			}

			// Default - show first tab
			tab.nav[0].classList.add('active')
			tab.txt[0].classList.add('active')
		}
	},

	switch: function () {
		// tab.switch() : change to another tab

		// Hide all tabs & text
		for (var t of tab.nav) {
			t.classList.remove('active')
		}
		for (var t of tab.txt) {
			t.classList.remove('active')
		}

		// Set current tab
		tab.nav[this.dataset.pos].classList.add('active')
		tab.txt[this.dataset.pos].classList.add('active')
	},
}

window.addEventListener('load', tab.init)
